<template>
  <div class="ec-map">
    <div class="ec-map__inner">
      <img src="../../../assets/img/china-map.png" alt="地图" class="map">
      <div class="scatter ec-map__scatter">
        <div
          class="scatter__item"
          v-for="item in scatterData"
          :key="item.orgId"
          :style="{left: item.coordinatePos.x + 'px', bottom: item.coordinatePos.y + 'px'}"
          >
            <div
              class="scatter__dot"
              >
              <div class="scatter__dot--0" :style="item.styles.stylesDot0">
              </div>
              <div class="scatter__dot--1" :style="item.styles.stylesDot1">
              </div>
              <div class="scatter__dot--2" :style="item.styles.stylesDot2">
              </div>
             </div>
            <div class="scatter__txt" :style="item.styles.stylesTxt">
              {{item.name}}
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EcMap',
  data () {
    return {
       eastLongitude: {
         max: 135.05,
         min: 73.33
       },
       northLatitude: {
         maxHack: 58.55, // 北京以南的 以这个点为依据
         max: 55.55, // 北京以北的 以这个点为依据
         min: 18.14
       },
       beijing: {
         eastLongitude: 116.407387,
         northLatitude: 40 // 模糊数值
       },
       map: {
         width: 448,
         height: 329
       }
    }
  },
  props: {
    data: {
      type: [Array, Object],
      default: () => {
        return []
      }
    }
  },
  computed: {
    eastLongitudeDis () {
      return this.eastLongitude.max - this.eastLongitude.min
    },
    northLatitudeDis () {
      return this.northLatitude.max - this.northLatitude.min
    },
    northLatitudeDisSouth () {
      return this.northLatitude.maxHack - this.northLatitude.min // 北京以南的 以这个点为依据
    },
    scatterData () {
      let data = this.data
      data.forEach(item => {
        let coordinate =this.calcCoordinate(item)
        let styles = this.calcStyles(item.order)
        item.coordinatePos = coordinate
        item.styles = styles
      });
      return data
    }
  },
  methods: {
    calcCoordinate (item) {
      // 北京以南的 以这个点为依据
      var northLatitudeDis = this.northLatitudeDis
      if (item.coordinate[1] < this.beijing.northLatitude) {
         northLatitudeDis = this.northLatitudeDisSouth
      }
      let x = (item.coordinate[0] - this.eastLongitude.min) / this.eastLongitudeDis * this.map.width
      let y = (item.coordinate[1] - this.northLatitude.min) / northLatitudeDis * this.map.height
      return {x, y}
    },
    calcStyles (order) {
      let maxVal = 10;
      let val = maxVal - order + 2
      let width =  val < 2 ? 2 : val;
      let height = width;
      let styles = {}
      styles.stylesDot0 = {
        width: `${width}px`,
        height: `${height}px`,
        marginTop: `-${width / 2}px`,
        marginLeft: `-${height / 2}px`
      }
      styles.stylesDot1 = {
        width: `${width + 14}px`,
        height: `${height + 14}px`,
        marginTop: `-${(width + 14) / 2}px`,
        marginLeft: `-${(height + 14) / 2}px`
      }
      styles.stylesDot2 = {
        width: `${width + 28}px`,
        height: `${height + 28}px`,
        marginTop: `-${(width + 28) / 2}px`,
        marginLeft: `-${(height + 28) / 2}px`
      }
      styles.stylesTxt = {
        left: `${(width + 28) / 2 + 2}px`
      }
      return styles
    }
  }
}
</script>
<style lang="scss" scoped>
// 地图
.ec-map {
  width: 100%;
  display: block;
  padding-bottom: 10px;
  &__inner {
    position: relative;
    display: inline-block;
    font-size: 0;
  }
  &__scatter {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.scatter {
  &__item {
    position: absolute;
  }
  &__dot {
    &:hover {
      cursor: pointer;
    }
    &:hover + .scatter__txt{
      z-index: 1;
      display: block !important;
    }
    &--1,
    &--2 {
      border: 2px solid #3ba9b2;
      border-radius: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      box-sizing: border-box;
    }
    &--1 {
      -webkit-animation: circle 1.5s ease-out infinite;
      animation: circle 1.5s ease-out infinite;
    }
    &--2 {
      -webkit-animation: circle 3s ease-out infinite;
      animation: circle 3s ease-out infinite;
    }
    &--0 {
      background: #3ba9b2;
      box-shadow: 1px 1px 10px #3ba9b2;
      border-radius: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
    }
  }
  .scatter__txt {
    display: none;
    font-size: 10px;
    color: #fff;
    position: absolute;
    top: 0;
    width: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dataIndex/components/EcMap.vue